<template>
  <div>
    <div>
      <div style="overflow: hidden" @click="UploadImg">
        <v-card
          flat
          v-model="svgBackground"
          style="overflow: hidden"
          v-if="Src == null"
        >
          <div  style="position: relative; background-color: #f5f8f8">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="VideoImageSVG"
              viewBox="0 0 197 113"
              fill="none"
            >
              <rect
                x="0.5"
                y="0.5"
                width="196"
                height="112"
                rx="3.5"
                fill="white"
                stroke="#E0E0E0"
                stroke-dasharray="6 6"
              />
              <text x="40" y="70" fill="rgba(8, 8, 22, 0.54)">
                Video Thumbnail
                <tspan x="50" y="90">(200x150px)</tspan>
              </text>
              <path
                d="M105 38V45H91V31H96.02C96.07 30.29 96.24 29.62 96.5 29H91C89.9 29 89 29.9 89 31V45C89 46.1 89.9 47 91 47H105C106.1 47 107 46.1 107 45V40L105 38ZM103.5 43H92.5L95.25 39.47L97.21 41.83L99.96 38.29L103.5 43ZM106.3 33.89C106.74 33.19 107 32.38 107 31.5C107 29.01 104.99 27 102.5 27C100.01 27 98 29.01 98 31.5C98 33.99 100.01 36 102.49 36C103.37 36 104.19 35.74 104.88 35.3L108 38.42L109.42 37L106.3 33.89ZM102.5 34C101.12 34 100 32.88 100 31.5C100 30.12 101.12 29 102.5 29C103.88 29 105 30.12 105 31.5C105 32.88 103.88 34 102.5 34Z"
                fill="#080816"
                fill-opacity="0.38"
              />
            </svg>
          </div>
        </v-card>
        <v-card v-model="UploadedImage" v-else>
          <img :src="Src" width="500" height="350" style="object-fit: cover;"/>
      </v-card>
      </div>
      <input
        type="file"
        accept="image/png, image/gif, image/jpeg"
        style="display: none"
        ref="Img"
        @change="SetImage"
        
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoImageUploaderComponent",
  props: {
    thumbnil: {
      type: String,
    },
  },
  data() {
    return {
      svgBackground: true,
      UploadedImage: false,
      SingleImage: {},
      img: {},
      cropper: {},
      destination: {},
      Src: null,
    };
  },
  async mounted() {
    if(this.thumbnil)
    {
      this.Src = this.thumbnil
      await this.getImage();
      this.concatBaseUrl(this.Src )
      console.log("this.thumbnil",this.thumbnil);
    }
  },
  methods: {
    concatBaseUrl(image){
      console.log("if ",image)
      if(image.includes("Generic")){
        this.Src =  image
      }else {
        console.log("esle ",image)
        // this.Src = process.env.VUE_APP_IMG_URL + image
        this.Src = image
      }
    },
    async getImage(){
      //var response = await axios.get(this.thumbnil, { responseType: 'blob' });
      //this.Src = response.data;
      console.log("image",this.Src);
      this.$emit("uploadImg", this.Src)
    },
    UploadImg() {
      this.$refs.Img.click();
    },
    SetImage() {
      var reader = new FileReader();
      reader.onload = () => {
        this.Src = reader.result;
        const base64Image = reader.result.split(",")[1];
        this.$emit("uploadImg", {
          file: this.$refs.Img.files[0],
          base64: base64Image,
        });
      };
      reader.readAsDataURL(this.$refs.Img.files[0]);
    },
  },
};
</script>

<style scoped>
.svgBackgroundSection {
  height: 16vh;
  overflow: hidden;
}
h1 {
  font-family: "DM Sans";
  font-size: 30px;
  font-weight: 400;
  line-height: 39px;
}
.check {
  background-image: url("../../assets/css/editract.svg");
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
}
.VideoImageSVG {
  width: 100%;
}
@media screen and (max-width: 430px) {
  .VideoImageSVG {
    width: 100%;
  }
}
</style>
